module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-card-container",
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "card-list"
  }, [_vm._l((_vm.pictures.media), function(pic, key) {
    return _c('div', [_c('div', {
      staticClass: "file-preview"
    }, [_c('div', {
      staticClass: "file-container"
    }, [(_vm.showVideo(pic)) ? [_c('video', {
      attrs: {
        "controls": "controls"
      },
      on: {
        "load": function($event) {
          _vm.onImageLoaded()
        }
      }
    }, [_c('source', {
      attrs: {
        "src": pic.path
      }
    })])] : [_c('image-helper', {
      attrs: {
        "src": _vm.isGif(pic.path) ? pic.path : pic.thumbnail
      }
    })]], 2)]), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "display-url-container"
    }, [_c('div', {
      staticClass: "title",
      class: {
        "has-btn": _vm.isCtaVisible
      }
    }, [_c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(_vm.caption(pic)))]), _c('div', {
      staticClass: "display-url",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.description(pic)))])]), (_vm.isCtaVisible) ? _c('b-btn', {
      staticClass: "cta-btn",
      on: {
        "click": function($event) {
          _vm.$emit('ctaClick')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('fn.complex.calltoaction', {
      calltoaction: _vm.pictures.cta
    })))]) : _vm._e()], 1)])])
  }), _c('div', {
    staticClass: "page-preview"
  }, [_c('div', {
    staticClass: "file-preview"
  }, [_c('div', {
    staticClass: "file-container"
  }, [_c('img', {
    attrs: {
      "src": _vm.facebookPage.picture
    }
  })])]), _c('a', {
    staticClass: "card-body small",
    attrs: {
      "href": _vm.landingPage.link,
      "target": "_blank"
    }
  }, [_c('div', [_c('div', [_vm._v(_vm._s(_vm.landingPage.see_more))]), _c('div', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.landingPageHostname))])])])])], 2), _c('div', {
    staticClass: "navigation-blocks",
    class: {
      "nav-images-active": _vm.navImageHover === 1
    }
  }, [_c('div', {
    staticClass: "nav-image prev-image",
    class: {
      "d-none": _vm.currentImage < 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage('prev')
      },
      "mouseover": _vm.hoverNavImage,
      "mouseleave": _vm.leaveNavImage
    }
  }, [_c('div', {
    staticClass: "prev-control"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-left"
    }
  })], 1)]), _c('div', {
    staticClass: "nav-image next-image",
    class: {
      "d-none": _vm.currentImage === _vm.mediaLength - 1
    },
    on: {
      "click": function($event) {
        _vm.changeImage('next')
      },
      "mouseover": _vm.hoverNavImage,
      "mouseleave": _vm.leaveNavImage
    }
  }, [_c('div', {
    staticClass: "next-control"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-right"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2055423c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/creative-preview/carousel/Carousel.vue
// module id = 2019
// module chunks = 1